import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import {
	deleteMonthlyFeeRequest,
	getEMerchantRequest,
	getFeeClassesRequest,
	getMonthlyFeeListRequest,
	getMonthlyFeeRequest,
} from 'redux/reducers/monthlyFee/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { getMonthlyFeeList, getMonthlyFeeListLoader } from 'redux/reducers/monthlyFee/selectors';
import {
	TMonthlyFeeListItem,
	TMonthlyFeeListRequestPayload,
} from 'redux/reducers/monthlyFee/types';
import { PAGE_SIZE } from 'services/constants/env';
import { DeleteDialog } from 'ui/DeleteDialog';
import { TTableStructure } from 'ui/EasTable/types';
import { CreateMonthlyFeeChangeRequestDialog } from './CreateMonthlyFeeChangeRequestDialog';
import { tableStructura } from './tableStructura';
import { EasTableWithFilter } from '../../ui/EasTableWithFilter';

export const MonthlyFee = () => {
	const dispatch = useDispatch();
	const { search } = useLocation();
	const { page, searchEmId } = queryString.parse(search);

	const monthlyFee = useSelector(getMonthlyFeeList);
	const dataIsLoad = useSelector(getMonthlyFeeListLoader);

	useEffect(() => {
		dispatch(getEMerchantRequest());
		dispatch(getMonthlyFeeRequest());
		dispatch(getFeeClassesRequest());
	}, [dispatch]);

	useEffect(() => {
		const paramsHandle: TMonthlyFeeListRequestPayload = {
			pageNumber: +(page || 1),
			pageSize: PAGE_SIZE,
			emId: searchEmId ? Number(searchEmId) : undefined,
		};

		dispatch(getMonthlyFeeListRequest(paramsHandle));
	}, [dispatch, search]);

	const [openCreateMonthlyFeeChangeRequestDialog, setOpenCreateMonthlyFeeChangeRequestDialog] =
		useState(false);

	const handleCreateMonthlyFeeChangeRequestDialog = () => {
		setOpenCreateMonthlyFeeChangeRequestDialog(true);
	};

	const handleCloseCreateMonthlyFeeChangeRequestDialog = () => {
		setOpenCreateMonthlyFeeChangeRequestDialog(false);
	};

	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	const [monthlyFeeIdForDelete, setMonthlyFeeIdForDelete] = useState<number | null>(null);

	const handleOpenDeleteDialog = (id: number) => {
		setMonthlyFeeIdForDelete(id);
		setOpenDeleteDialog(true);
	};

	const handleCloseDeleteDialog = () => {
		setOpenDeleteDialog(false);
	};

	const handleDeleteMonthlyFee = () => {
		setOpenDeleteDialog(false);
		if (!monthlyFeeIdForDelete) return;
		dispatch(deleteMonthlyFeeRequest({ monthlyFeeId: monthlyFeeIdForDelete }));
	};

	const handleAction = (id: number, action: string) => {
		if (action === 'Delete') {
			handleOpenDeleteDialog(id);
		}
	};

	return (
		<Box sx={{ margin: '0px 10px 0 10px' }}>
			<EasTableWithFilter<TMonthlyFeeListItem>
				items={monthlyFee}
				itemsIsLoading={dataIsLoad}
				tableStructure={
					tableStructura as TTableStructure<keyof TMonthlyFeeListItem, TMonthlyFeeListItem>[]
				}
				handleAction={handleAction}
				handleLink={() => {}}
				highlightedRow={null}
				emFilter
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						width: '100%',
						padding: '0 0 0 8px',
					}}
				>
					<Typography variant="body1" color="primary" fontWeight="bold">
						Monthly Fee
					</Typography>
					<Button
						variant="contained"
						onClick={handleCreateMonthlyFeeChangeRequestDialog}
						size="small"
						sx={{ p: 1, height: '30px' }}
					>
						Create Monthly Fee Change Request
					</Button>
				</Box>
			</EasTableWithFilter>
			<DeleteDialog
				open={openDeleteDialog}
				setClose={handleCloseDeleteDialog}
				handleDelete={handleDeleteMonthlyFee}
				text="Are you sure you want to delete this position?"
			/>
			<CreateMonthlyFeeChangeRequestDialog
				open={openCreateMonthlyFeeChangeRequestDialog}
				setClose={handleCloseCreateMonthlyFeeChangeRequestDialog}
			/>
		</Box>
	);
};
